import { useEffect, useState, useRef} from 'react';
import { useDispatch } from 'react-redux';
import { useSelector } from 'react-redux';
import { Box,Text,Button,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Input,Image,useToast,Link } from '@chakra-ui/react';
import { selectedMenu } from "../../redux/actions/actions";
import { generateAttendance,loadAttendance } from '../../redux/api_calls/apiCalls'

export default function CalendarSchedule() {
    const toast = useToast();
    const { attendanceData } = useSelector(state => state.attendanceState)
    
    const slider = useSelector(state => state.sliderState.sliderOpen)
    const dispatch = useDispatch()
    const [centerNameValue, setCenterNameValue] = useState("");
    const [sessionNameValue, setSessionNameValue] = useState("");
    const [centerNameError, setCenterNameError] = useState(null);
    const [dateError, setDateError] = useState(null);
    const [sessionNameError, setSessionNameError] = useState(null);
    const endDateRef = useRef();

  
    useEffect(() => {
        
        dispatch(selectedMenu(7));
        dispatch(loadAttendance());
    }, [dispatch])
    

    const saveAttendance = async () => {
        let centerName = document.getElementById('center_name').value;
        if (!centerName.length) {
            setCenterNameError("Center Name is required")
            return true
        }
        if(endDateRef.current.value ==='')
        {
            setDateError("Date is required");
            return
        }
        let session = document.getElementById('session_name').value;
        if (!session.length) {
            setSessionNameError("Session Name is required")
            return true
        } 
        let obj = {
                center_name: centerName,
                date: endDateRef.current.value,
                session_name: session
            }
            try {
            await generateAttendance(obj);
             dispatch(loadAttendance());
            
            toast({
                title: "Attendance has been added Successfully!",
                status: "success",
                duration: 1000,
                isClosable: true,
            });
           
        }
        catch (err) {
              toast({
                title: err.response.data.message,
                description: "",
                status: "error",
                duration: 3000,
                isClosable: true,
              });
            }
        
    }

    return (
        <Box
            d='flex'
            justifyContent='flex-start'
            alignItems='center'
            flexDirection='column'
            minH='90vh'
            pl={['0', '0', '0', slider ? window.innerWidth < 1400 ? '18vw' : '13vw' : '7.5vw']}
            transition='all 350ms ease'
        >

            <Box width={['95%', '95%', '95%', '80%']} justifyContent='space-between' alignItems='center' d='flex' mb='2rem'>
                <Text fontSize={['20px', '25px', '30px', '40px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }}>Generate QR Code</Text>
                
            </Box>
            <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="space-between"
                mb="1rem"
                bgColor='white'
                pl='1rem'
                pb='1rem'
                pr='1rem'
                pt='1rem'
                borderRadius='10px'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
            >
            <Box width="25%">
                            <FormControl isInvalid={centerNameError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Center Name
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="center_name"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    value={centerNameValue}
                                    onChange={(e) => {
                                        setCenterNameError(null);
                                        setCenterNameValue(e.target.value);
                                    }}
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {centerNameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="25%">
                            <FormControl isInvalid={dateError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Select Date
                                </FormLabel>
                                <Input
                                    type="date"
                                    color="#666666"
                                    id="date"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                   ref={endDateRef}
                                     onChange={() => {
                                      if (endDateRef.current.value.trim().length > 0) {
                                        setDateError(null);
                                      }
                                    }}
                                    
                                />
                                <FormErrorMessage fontSize="sm">
                                    {dateError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="25%">
                            <FormControl isInvalid={sessionNameError}>
                                <FormLabel
                                    variant="custom"
                                    style={{ fontFamily: "Mulish, sans-serif" }}
                                >
                                    Session Name
                                </FormLabel>
                                <Input
                                    type="text"
                                    color="#666666"
                                    id="session_name"
                                    width="100%"
                                    borderRadius="lg"
                                    bgColor="white"
                                    fontSize={["9px", "11px", "13px", "16px"]}
                                    value={sessionNameValue}
                                    onChange={(e) => {
                                        setSessionNameError(null)
                                        setSessionNameValue(e.target.value);
                                    }}
                                />
                                <FormErrorMessage fontSize="sm">
                                    {sessionNameError}
                                </FormErrorMessage>
                            </FormControl>
                        </Box>
                        <Box width="20%" pt='2rem'>
                            <Button
                                bgColor="#4a86e8"
                                color="#ffffff"
                                borderRadius="lg"
                                border="1px solid 4a86e8"
                                p={["6px 15px", "8px 20px", "12px 30px"]}
                                style={{ fontFamily: "Mulish, sans-serif" }}
                                fontWeight="800"
                                fontSize={["13px", "14px", "16px"]}
                                onClick={saveAttendance}
                              >
                            Generate
                          </Button>
                        </Box>
               
            </Box>
             <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="flex-start"
                mb="1rem"
                bgColor='white'
                pl='1rem'
                pb='1rem'
                pr='1rem'
                pt='1rem'
                borderRadius='10px'
                flexDirection='column'
                boxShadow='0px 2px 10px rgba(0, 0, 0, 0.1)'
            >
            {attendanceData &&
            <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="flex-start"
                mb="1rem"
                pl='1rem'
                pb='1rem'
                pr='1rem'
                pt='1rem'
                borderRadius='10px'

            >
            
             <Box width="25%">

                <Image src={attendanceData.qr_code} width='150px'/>                 

             </Box>
              <Box width="65%">
                   <Text fontSize={['15px', '15px', '15px', '15px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} pb='0.5rem'>Session Name : {attendanceData.session_name}</Text>
                   <Text fontSize={['15px', '15px', '15px', '15px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} pb='0.5rem'>Date : {attendanceData.date}</Text>
                     <Button
                         pb='0.5rem'
                        bgColor="#4a86e8"
                        color="#ffffff"
                        border="1px solid 4a86e8"
                        p={["6px 15px", "8px 20px", "12px 30px"]}
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="800"
                        fontSize={["13px", "14px", "16px"]}
                              >
                            Print QR Code
                          </Button>
              </Box>



            </Box>
        }
        <Box
                width={["100%", "100%", "90%", "85%"]}
                d="flex"
                justifyContent="flex-start"
                mb="1rem"
                pl='1rem'
                pb='1rem'
                pr='1rem'
                pt='1rem'
                borderRadius='10px'

            >
       
            <Box width="100%">
                   <Text fontSize={['15px', '15px', '15px', '15px']} d={['none', 'none', 'none', 'flex']} fontWeight='900' style={{ fontFamily: 'Mulish, sans-serif' }} pb='0.5rem'>NOTE :</Text>
                   <Text fontSize={['15px', '15px', '15px', '15px']} d={['none', 'none', 'none', 'flex']}  style={{ fontFamily: 'Mulish, sans-serif' }} pb='0.5rem'>1 : The QR code generated valid only this session and cannot be for any further session</Text>
                    <Text fontSize={['15px', '15px', '15px', '15px']} d={['none', 'none', 'none', 'flex']}  style={{ fontFamily: 'Mulish, sans-serif' }} pb='0.5rem'>2 : The QR code expires within 24 hrs of generation</Text>
 
              </Box>


            </Box>
            <Box width="100%">
                  <Link href='https://epic-brattain-a679ce.netlify.app/user-feedback' isExternal
                         pb='0.5rem'
                        bgColor="#4a86e8"
                        color="#ffffff"
                        border="1px solid 4a86e8"
                        borderRadius='10px'
                        p={["6px 15px", "8px 20px", "12px 30px"]}
                        style={{ fontFamily: "Mulish, sans-serif" }}
                        fontWeight="800"
                        fontSize={["13px", "14px", "16px"]}
                              >
                            View Survey Form
                          </Link>
              </Box>
            </Box>
           
       
        </Box>
    )
}
